/**
 * Тексти модулів WSDMS (реєстр, оцінювання, персонал, облік часу, послуги, акти, аналітика).
 * Частина `uk` з `uk.ts` — винесено окремо, щоб файл лишався читабельним.
 */
export const ukWsdms = {
  registry: {
    projects: 'Проєкти',
    project: 'Проєкт',
    newProject: 'Новий проєкт',
    editProject: 'Редагувати проєкт',
    code: 'Код',
    codeHint: 'Короткий код, напр. UNHCR-PROT-26. Він з’являється в назвах конкурсів.',
    name: 'Назва',
    donor: 'Донор',
    period: 'Період',
    startsAt: 'Початок',
    endsAt: 'Завершення',
    endsAtHint: 'Порожньо — безстроково',
    budget: 'Бюджет',
    allocated: 'Заплановано на персонал',
    remaining: 'Залишок',
    manager: 'Керівник програми',
    managerHint: 'Другий рівень погодження звітів про послуги',
    status: 'Статус',
    description: 'Опис',
    staffCount: 'Штатних одиниць',
    fteTotal: 'FTE разом',
    projectCreated: 'Проєкт створено',
    emptyProjects: 'Проєктів ще немає',
    emptyProjectsHint: 'Заведіть проєкт донора з бюджетом, а потім — штатні одиниці.',
    budgetLines: 'Бюджетні статті',
    budgetLine: 'Бюджетна стаття',
    budgetLineCode: 'Код',
    budgetLineAmount: 'Сума',
    budgetLineAllocated: 'Заплановано',
    addBudgetLine: 'Додати статтю',
    noBudgetLine: 'Без статті',
    exportStaffing: 'Штатний розклад у Excel',
    staffing: 'Штатний розклад',
    staffingDescription: 'Затверджені посади в проєктах: FTE, ставки, зайнятість',
    staffPosition: 'Штатна одиниця',
    newStaffPosition: 'Нова штатна одиниця',
    editStaffPosition: 'Штатна одиниця',
    position: 'Посада',
    center: 'Центр',
    location: 'Місто',
    contractKind: 'Тип контракту',
    fte: 'FTE',
    fteHint: '1 — повна зайнятість, 0,5 — половина',
    rate: 'Ставка',
    rateUnit: 'Одиниця ставки',
    occupancy: 'Зайнятість',
    occupied: (occ: number, fte: number) => `${occ} з ${fte} FTE`,
    estimatedCost: 'Оцінка вартості',
    estimatedCostHint: 'Ставка × FTE × місяці дії (до кінця проєкту, якщо безстрокова)',
    duties: 'Опис посади і функціональні обов’язки',
    dutiesPlaceholder: 'Обов’язки, підпорядкування, умови роботи…',
    requirements: 'Вимоги до кандидатів',
    requirementsPlaceholder: 'Освіта, досвід, навички, мови, водійське посвідчення…',
    services: 'Послуги посади',
    servicesHint: 'Що може звітувати працівник на цій посаді (модуль 5)',
    criteria: 'Критерії оцінки кандидатів',
    criteriaHint: 'Копіюються в конкурс на цю штатну одиницю',
    criterionName: 'Критерій',
    maxScore: 'Макс. бал',
    weight: 'Вага',
    minScore: 'Мін. бал',
    addCriterion: 'Додати критерій',
    defaultCriteria: 'Типовий набір',
    contests: 'Конкурси на цю посаду',
    noContests: 'Конкурсів ще не було',
    newContest: 'Оголосити конкурс',
    emptyStaffing: 'Штатних одиниць ще немає',
    emptyStaffingHint: 'Додайте затверджені посади проєкту: посаду, центр, FTE і ставку.',
    staffPositionCreated: 'Штатну одиницю створено',
    resetFilters: 'Скинути фільтри',
    searchPlaceholder: 'Пошук за посадою, проєктом, центром…',
    tabInfo: 'Загальне',
    tabStaff: 'Штатні одиниці',
    tabBudget: 'Бюджет',
    over: 'Перевищено',
    fromRegistry: 'Штатна одиниця',
    fromRegistryHint: 'Посада, місто і проєкт підставляться з реєстру',
    projectFromRegistry: 'Проєкт з реєстру',
    projectFreeText: 'або код вручну',
    donors: 'Донори',
    centers: 'Гуманітарні центри',
    servicesCatalog: 'Каталог послуг',
    centerManager: 'Керівник центру',
    centerManagerHint: 'Перший рівень погодження звітів',
    address: 'Адреса',
    serviceUnit: 'Одиниця',
    serviceCode: 'Код',
    serviceDescription: 'Стандартизований опис',
    notes: 'Нотатки',
    none: 'Не вказано',
  },
  evaluation: {
    tab: 'Оцінювання',
    criteria: 'Критерії оцінки',
    criteriaEmpty: 'Критерії ще не задано',
    criteriaInit: 'Взяти з посади або типовий набір',
    criteriaSave: 'Зберегти критерії',
    criteriaSaved: 'Критерії збережено',
    committee: 'Комісія',
    committeeEmpty: 'Комісію ще не сформовано',
    committeeAdd: 'Додати до комісії',
    committeeSaved: 'Склад комісії збережено',
    committeeHint:
      'Член комісії бачить бали інших лише після того, як завершить власну оцінку кандидата.',
    rating: 'Рейтинг кандидатів',
    rank: 'Місце',
    candidate: 'Кандидат',
    total: 'Бал, %',
    submissions: 'Оцінок',
    belowMinimum: 'Нижче мінімуму',
    hidden: 'Завершіть свою оцінку, щоб побачити результати',
    evaluate: 'Оцінити',
    reevaluate: 'Змінити оцінку',
    continue: 'Продовжити',
    dialogTitle: (name: string) => `Оцінка: ${name}`,
    score: 'Бал',
    scoreOf: (max: number) => `з ${max}`,
    criterionComment: 'Коментар до критерію',
    overallComment: 'Загальний коментар',
    saveDraft: 'Зберегти чернетку',
    submit: 'Завершити оцінку',
    submitted: 'Оцінку завершено',
    draftSaved: 'Чернетку збережено',
    yourScore: (v: string) => `Ваш бал: ${v}%`,
    makeWinner: 'Визнати переможцем',
    exportRating: 'Рейтинг у Excel',
    exportProtocol: 'Протокол у Word',
    notMember: 'Ви не в комісії цього конкурсу — оцінювати можуть лише її члени.',
    noCandidates: 'У конкурсі ще немає кандидатів',
  },
  documents: {
    kind: 'Тип документа',
  },
  personnel: {
    employees: 'Працівники',
    employee: 'Працівник',
    newEmployee: 'Новий працівник',
    editEmployee: 'Дані працівника',
    fullName: 'ПІБ',
    lastName: 'Прізвище',
    firstName: 'Ім’я',
    middleName: 'По батькові',
    phone: 'Телефон',
    email: 'Email',
    taxId: 'РНОКПП',
    taxIdBirthMismatch: 'Дата народження не збігається з РНОКПП',
    birthDate: 'Дата народження',
    address: 'Адреса',
    iban: 'IBAN',
    bankName: 'Банк',
    notes: 'Нотатки',
    status: 'Статус',
    hiredAt: 'Прийнято',
    dismissedAt: 'Звільнено',
    currentPositions: 'Поточні посади',
    currentFte: 'FTE',
    account: 'Обліковий запис',
    hasAccount: 'Є доступ до кабінету',
    empty: 'Працівників ще немає',
    emptyHint:
      'Працівники з’являються, коли переможця конкурсу оформлюють на посаду, або їх додають вручну.',
    searchPlaceholder: 'ПІБ, телефон або РНОКПП…',
    created: 'Працівника створено',
    tabAssignments: 'Призначення',
    tabContracts: 'Договори',
    tabDocuments: 'Особова справа',
    tabOnboarding: 'Онбординг',
    tabProfile: 'Дані',
    assignment: 'Призначення',
    addAssignment: 'Призначити на посаду',
    assignmentCreated: 'Призначення збережено',
    overloaded: (fte: number) => `Увага: сумарне навантаження працівника ${fte} FTE (більше 1)`,
    endAssignment: 'Завершити',
    noAssignments: 'Призначень немає',
    contract: 'Договір',
    contracts: 'Договори',
    newContract: 'Новий договір',
    contractCreated: 'Договір створено',
    number: 'Номер',
    kind: 'Тип',
    signedAt: 'Підписано',
    sign: 'Позначити підписаним',
    signed: 'Договір підписано',
    startsAt: 'Початок',
    endsAt: 'Завершення',
    rate: 'Ставка',
    totalCap: 'Гранична сума',
    terms: 'Особливі умови',
    downloadDocx: 'Договір у Word',
    amendments: 'Додаткові угоди',
    addAmendment: 'Додаткова угода',
    amendmentCreated: 'Додаткову угоду створено',
    amendmentText: 'Зміст угоди',
    newRate: 'Нова ставка',
    newEndsAt: 'Нова дата завершення',
    noContracts: 'Договорів немає',
    expiring: 'Закінчуються протягом 30 днів',
    documents: 'Документи',
    documentType: 'Тип документа',
    noType: 'Без типу',
    expiresAt: 'Діє до',
    missing: 'Бракує обов’язкових документів',
    complete: 'Особова справа укомплектована',
    uploadFor: (name: string) => `Завантажити: ${name}`,
    uploaded: (n: number) => `Завантажено файлів: ${n}`,
    expired: 'Строк дії минув',
    onboarding: 'Чекліст прийняття',
    addTask: 'Додати пункт',
    onboardingProgress: (done: number, total: number) => `Виконано ${done} з ${total}`,
    dismiss: 'Звільнити',
    dismissTitle: 'Звільнення працівника',
    dismissHint: 'Усі активні призначення і договори буде завершено цією датою.',
    dismissDate: 'Дата звільнення',
    dismissReason: 'Причина',
    dismissed: 'Працівника звільнено',
    createAccount: 'Створити доступ до кабінету',
    accountTitle: 'Доступ до кабінету працівника',
    accountHint:
      'Працівник отримає лист-запрошення, задасть пароль і зможе заповнювати табель і звіти про надані послуги.',
    accountCreated: 'Доступ створено.',
    password: 'Пароль',
    copy: 'Копіювати',
    copied: 'Скопійовано',
    hire: 'Оформити працівника',
    hireTitle: 'Оформлення переможця на посаду',
    hireHint: 'Буде створено картку працівника, призначення на штатну одиницю і чернетку договору.',
    hireStaffPosition: 'Штатна одиниця',
    hireCreateContract: 'Створити чернетку договору',
    hired: 'Працівника оформлено',
    openEmployee: 'Картка працівника',
    templates: 'Шаблони документів',
    templatesHint:
      'Завантажте свій DOCX з полями у фігурних дужках, напр. {employee_full_name}. Діє останній завантажений шаблон типу; без нього — типовий.',
    templateDefault: 'Типовий шаблон',
    templateUpload: 'Завантажити шаблон',
    templateUploaded: 'Шаблон завантажено',
    templateFields: 'Поля для підстановки',
    templateCurrent: 'Чинний',
    documentTypes: 'Документи особової справи',
    requiredFor: 'Обов’язковий для',
    allContracts: 'усіх договорів',
    required: 'Обов’язковий',
  },
  time: {
    calendar: 'Виробничий календар',
    calendarHint:
      'Робочі, вихідні, святкові й скорочені дні. Під час воєнного стану свята — робочі дні (позначені приміткою).',
    notStored:
      'Календар на цей рік ще не збережено — показано типовий. Згенеруйте рік, щоб редагувати дні.',
    generate: 'Згенерувати рік',
    generateTitle: 'Генерація календаря',
    hoursPerDay: 'Норма годин на день',
    holidaysOff: 'Свята — вихідні дні (поза воєнним станом)',
    overwrite: 'Перезаписати змінені вручну дні',
    generated: 'Календар збережено',
    dayKind: 'Тип дня',
    hours: 'Годин',
    note: 'Примітка',
    workingDays: 'Робочих днів',
    norm: 'Норма, год',
    timesheets: 'Табелі',
    timesheet: 'Табель',
    month: 'Місяць',
    planned: 'План, год',
    actual: 'Факт, год',
    absenceDays: 'Днів відсутності',
    notStarted: 'Не заповнено',
    emptyMonth: 'У цьому місяці немає працівників з призначеннями',
    export: 'Табель у Excel',
    fillPlan: 'Заповнити за планом',
    fillPlanConfirm: 'Поточні записи табеля буде замінено плановими.',
    save: 'Зберегти табель',
    saved: 'Табель збережено',
    submit: 'Подати на погодження',
    submitted: 'Табель подано',
    approve: 'Погодити',
    approved: 'Табель погоджено',
    return: 'Повернути',
    returned: 'Табель повернуто',
    returnComment: 'Причина повернення',
    returnedBy: 'Повернуто з коментарем',
    absenceRow: 'Відсутність',
    total: 'Разом',
    issues: {
      over_24h: 'більше 24 годин',
      hours_on_absence: 'години в день відсутності',
      weekend_work: 'робота у вихідний',
      outside_assignment: 'поза періодом призначення',
      over_day_norm: 'понад норму дня',
    },
    issuesTitle: 'Перевірки',
    unsaved: 'Є незбережені зміни',
    prevMonth: 'Попередній місяць',
    nextMonth: 'Наступний місяць',
  },
  cabinet: {
    title: 'Мій кабінет',
    timesheet: 'Мій табель',
    reports: 'Мої звіти',
    noEmployee: 'Ваш обліковий запис ще не прив’язано до картки працівника. Зверніться до HR.',
    positions: 'Мої посади',
  },
  reports: {
    title: 'Звіти про послуги',
    awaiting: 'Очікують мого погодження',
    all: 'Усі звіти',
    newReport: 'Новий звіт',
    editReport: 'Звіт про послугу',
    date: 'Дата',
    assignment: 'Посада / проєкт',
    service: 'Послуга',
    servicePlaceholder: 'Оберіть послугу з каталогу посади',
    location: 'Населений пункт (КАТОТТГ)',
    locationPlaceholder: 'Почніть вводити назву…',
    address: 'Адреса / місце',
    description: 'Що зроблено',
    descriptionPlaceholder: 'Коротко: кому, яку допомогу надано, результат',
    hours: 'Витрачено годин',
    quantity: 'Кількість',
    beneficiaries: 'Отримувачів',
    employee: 'Працівник',
    status: 'Статус',
    violations: 'Порушення',
    created: 'Звіт збережено',
    submit: 'Подати',
    submitSelected: (n: number) => `Подати вибрані (${n})`,
    submitted: (n: number) => `Подано звітів: ${n}`,
    approve: 'Погодити',
    approveSelected: (n: number) => `Погодити вибрані (${n})`,
    approved: (n: number) => `Погоджено звітів: ${n}`,
    return: 'Повернути',
    returnComment: 'Що виправити',
    returned: 'Звіт повернуто',
    remove: 'Видалити чернетку',
    empty: 'Звітів немає',
    emptyMine: 'За цей місяць звітів ще немає',
    emptyAwaiting: 'Немає звітів, що чекають вашого погодження',
    history: 'Історія погодження',
    level: { center: 'керівник центру', program: 'керівник програми', hr: 'HR' },
    awaitingLevel: (who: string) => `Чекає: ${who}`,
    exportExcel: 'Зведення в Excel',
    period: 'Період',
    withViolations: 'Тільки з порушеннями',
    violation: {
      future_date: 'дата в майбутньому',
      outside_contract: 'поза строком договору',
      outside_assignment: 'поза періодом призначення',
      service_not_allowed: 'послуга не з каталогу посади',
      absence_day: 'день відсутності в табелі',
      exceeds_timesheet: 'години перевищують табель',
      location_outside_area: 'поза зоною роботи центру',
      location_missing: 'не вказано населений пункт',
    },
    checksTitle: 'Автоматичні перевірки',
    checksOk: 'Перевірки пройдено',
    areaCodes: 'Зона роботи (КАТОТТГ)',
    areaHint: 'Області, райони чи громади, де центр надає послуги. Порожньо — без обмежень.',
    addArea: 'Додати територію',
    totals: (n: number, h: number) => `Звітів: ${n} · годин: ${h}`,
  },
  finance: {
    acts: 'Акти наданих послуг',
    act: 'Акт',
    generate: 'Сформувати акти',
    generateTitle: 'Формування актів за місяць',
    generateHint: 'Договори ЦПД і ФОП з погодженими звітами, які ще не увійшли в акти.',
    generated: (n: number) => `Сформовано актів: ${n}`,
    nothingToGenerate: 'Немає погоджених звітів поза актами за цей місяць',
    number: 'Номер',
    contract: 'Договір',
    employee: 'Виконавець',
    reports: 'Звітів',
    hours: 'Годин',
    quantity: 'Одиниць',
    amount: 'Сума',
    formula: 'Розрахунок',
    status: 'Статус',
    document: 'Акт у Word',
    annex: 'Додаток (перелік звітів)',
    reconciliation: 'Звірка з табелем',
    reconciliationIssue: (date: string, ts: string, rep: string) =>
      `${date}: звіти ${rep} год, табель ${ts}`,
    noTimesheet: 'немає',
    capped: 'обмежено граничною сумою договору',
    emptyActs: 'Актів за цей місяць немає',
    issue: 'Виставити',
    sign: 'Підписано',
    cancel: 'Скасувати акт',
    cancelHint: 'Звіти акта стануть доступними для нового акта.',
    registers: 'Реєстри винагород',
    register: 'Реєстр',
    build: 'Сформувати реєстр',
    buildTitle: 'Реєстр винагород проєкту за місяць',
    buildHint:
      'Трудові договори — з табелів, ЦПД і ФОП — з актів місяця. Чернетку можна перебудувати.',
    rebuild: 'Перебудувати',
    built: 'Реєстр сформовано',
    lines: 'Рядків',
    total: 'Разом',
    basis: { timesheet: 'Табель', act: 'Акт' } as Record<string, string>,
    missingRequisites: 'Немає РНОКПП або IBAN — бухгалтерія не проведе оплату',
    send: 'Передати в бухгалтерію',
    sent: 'Передано',
    markPaid: 'Позначити оплаченим',
    paid: 'Оплачено',
    exportXlsx: 'Excel для бухгалтерії',
    exportCsv: 'CSV для імпорту',
    emptyRegisters: 'Реєстрів ще немає',
    month: 'Місяць',
    taxId: 'РНОКПП',
    iban: 'IBAN',
  },
  analytics: {
    title: 'Аналітика і звітність',
    period: 'Період',
    donorReport: 'Звіт для донора (Excel)',
    donorReportHint: 'Оберіть проєкт, щоб сформувати звіт для донора',
    tabOverview: 'Огляд',
    tabStaff: 'Персонал',
    tabProjects: 'Проєкти і бюджет',
    tabServices: 'Послуги і географія',
    tabRecruitment: 'Рекрутинг',
    headcount: 'Працівників і надавачів',
    fte: 'FTE зайнято / за штатом',
    vacancies: 'Вакантних одиниць',
    utilization: 'Виконання плану годин',
    reports: 'Погоджених звітів',
    beneficiaries: 'Отримувачів',
    hromadas: 'Громад охоплено',
    accrued: 'Нараховано',
    byContractKind: 'За типом договору',
    byCenter: 'Зайнятість за центрами (FTE)',
    occupancy: 'Штатні одиниці за статусом',
    planFact: 'План і факт годин (табелі)',
    plan: 'План',
    fact: 'Факт',
    budget: 'Бюджет',
    planned: 'Заплановано на персонал',
    accruedMonth: 'Нараховано за місяцями',
    servicesByMonth: 'Одиниці послуг за місяцями',
    servicesByType: 'За видами послуг',
    byOblast: 'За областями',
    byHromada: 'За громадами',
    contests: 'Конкурсів за період',
    avgDays: 'Середній строк до закриття, днів',
    funnel: 'Воронка етапів',
    sources: 'Джерела кандидатів',
    hiredOf: (h: number, a: number) => `${a} відгуків · ${h} прийнято`,
    table: 'Таблиця',
    noData: 'Немає даних за період',
  },
  archive: {
    title: 'Архів документів',
    kinds: {
      contract: 'Договори',
      amendment: 'Додаткові угоди',
      act: 'Акти',
      protocol: 'Протоколи комісій',
      register: 'Реєстри винагород',
      personnel: 'Особові справи',
      candidate: 'Документи кандидатів',
    } as Record<string, string>,
    allKinds: 'Усі типи',
    open: 'Відкрити картку',
    view: 'Переглянути',
    empty: 'Документів не знайдено',
    limit: 'Показано до 300 найновіших — уточніть пошук',
  },
} as const;
